import React, { useCallback, useEffect } from 'react';
import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { MenuButtonBold, MenuButtonBulletedList, MenuButtonItalic, MenuButtonOrderedList, MenuButtonStrikethrough, MenuControlsContainer, MenuDivider, MenuSelectHeading, RichTextEditorProvider, RichTextField } from 'mui-tiptap';
import debounce from 'lodash/debounce';
import { ListItem } from '@mui/material';
export function TextEditor({ onContentChange, label, defaultValue, disabled }) {
    const handleUpdate = useCallback(debounce(editor => {
        if (onContentChange) {
            onContentChange(editor.getHTML(), label);
        }
    }, 500), [onContentChange]);
    const editor = useEditor({
        extensions: [StarterKit],
        content: defaultValue ?? '',
        onUpdate: ({ editor }) => handleUpdate(editor)
    });
    useEffect(() => {
        if (editor) {
            editor.setEditable(!disabled);
        }
    }, [disabled, editor]);
    // <MenuButtonUnderline /> não está incuído no StarterKit
    return (<RichTextEditorProvider editor={editor}>
      <RichTextField disabled={disabled} controls={<MenuControlsContainer>
            <MenuSelectHeading />
            <MenuDivider />
            <MenuButtonBold />
            <MenuButtonItalic />
            <MenuButtonStrikethrough />
            <MenuButtonBulletedList />
            <MenuButtonOrderedList />
            <ListItem />
          </MenuControlsContainer>}/>
    </RichTextEditorProvider>);
}
